// extracted by mini-css-extract-plugin
module.exports = {"Challenges":"Challenges_Challenges__hSucR"};